import { customElement } from 'lit/decorators.js';
import { TuftsFooter } from '../tufts-footer/tufts-footer';
import componentStyle from './tufts-footer-thin.css.lit';
import footerStyle from '../tufts-footer/tufts-footer.css.lit';

@customElement('tufts-footer-thin')
export class TuftsFooterThin extends TuftsFooter {
  static styles = [footerStyle, componentStyle];
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-footer-thin': TuftsFooterThin;
  }
}
